import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
let accessTokenProvider = async () => null;

if (!supabaseUrl || !supabaseKey) {
  throw new Error(
    "Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY. " +
    "Set them in your .env file or CI environment."
  );
}

export const setSupabaseAccessTokenProvider = (provider) => {
  accessTokenProvider = provider ?? (async () => null);
};

export const clearSupabaseAccessTokenProvider = () => {
  accessTokenProvider = async () => null;
};

// Supabase uses externally supplied Auth0 JWTs here, so supabase.auth should stay unused.
export const supabase = createClient(supabaseUrl, supabaseKey, {
  accessToken: async () => accessTokenProvider(),
});
